"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeatureFlagsUserBinder = void 0;
const react_1 = require("react");
const growthbook_react_1 = require("@growthbook/growthbook-react");
const AuthContext_1 = require("../../hooks/auth/context/AuthContext");
const FeatureFlagsUserBinder = () => {
    const growthbook = (0, growthbook_react_1.useGrowthBook)();
    const { userInfo } = (0, AuthContext_1.useAuth)();
    const email = userInfo?.email;
    (0, react_1.useEffect)(() => {
        if (!growthbook || !email)
            return;
        growthbook.setAttributes({
            ...growthbook.getAttributes(),
            email,
        });
    }, [growthbook, email]);
    return null;
};
exports.FeatureFlagsUserBinder = FeatureFlagsUserBinder;
